import React from 'react'

import style from './Postman.module.scss'

const Postman = ({
  id,
  onClick
}) => (
  <div className={style.postman} onClick={onClick}>
    <div
      className="postman-run-button"
      data-postman-action="collection/import"
      data-postman-var-1={id}>
    </div>
  </div>
)

export default Postman